/**
 * Il piede dell'elenco: dove sei, quanti sono, come vai avanti.
 *
 * Nel v2 al posto di questo c'è un campo con dentro "100" — un limite di
 * righe scritto a mano — e un contatore che dice "100/100". Su 1.196 clienti
 * non c'è modo di sapere quanti ne mancano, e chi cerca qualcosa di vecchio
 * deve indovinare un numero più grande.
 */

import { numero } from '../formati.js';
import { t } from '../i18n/lingua.js';

interface Props {
  pagina: number;
  pagine: number;
  totale: number;
  dimensione: number;
  onPagina: (pagina: number) => void;
  onDimensione: (dimensione: number) => void;
  nomePlurale: string;
}

const DIMENSIONI = [25, 50, 100, 200];

export function PiedeElenco({
  pagina,
  pagine,
  totale,
  dimensione,
  onPagina,
  onDimensione,
  nomePlurale,
}: Props) {
  const primo = totale === 0 ? 0 : (pagina - 1) * dimensione + 1;
  const ultimo = Math.min(pagina * dimensione, totale);
  return (
    <div className="table-foot">
      <span>
        {totale === 0
          ? t('Nessun risultato')
          : primo > totale
            ? // una pagina oltre la fine (un indirizzo vecchio, un filtro che ha
              // ristretto l'elenco): «499.901–32.886 di 32.886» non voleva dire niente
              t('Questa pagina è oltre la fine: {totale} {nome} in {pagine} pagine', {
                totale: numero(totale),
                nome: nomePlurale,
                pagine: numero(pagine),
              })
            : t('{primo}–{ultimo} di {totale} {nome}', {
                primo: numero(primo),
                ultimo: numero(ultimo),
                totale: numero(totale),
                nome: nomePlurale,
              })}
      </span>
      <span className="pager">
        <button className="btn" onClick={() => onPagina(pagina - 1)} disabled={pagina <= 1}>
          ←
        </button>
        <span className="num">
          {t('Pagina {n} di {m}', { n: numero(pagina), m: numero(pagine) })}
        </span>
        <button className="btn" onClick={() => onPagina(pagina + 1)} disabled={pagina >= pagine}>
          →
        </button>
        <select
          className="select"
          style={{ height: 24, width: 'auto', fontSize: 12 }}
          value={dimensione}
          onChange={(e) => onDimensione(Number(e.target.value))}
          aria-label={t('Righe per pagina')}
        >
          {DIMENSIONI.map((n) => (
            <option key={n} value={n}>
              {t('{n} righe', { n })}
            </option>
          ))}
        </select>
      </span>
    </div>
  );
}
